// src/components/game/MathQuiz.jsx
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const MathQuiz = ({ isDarkMode }) => {
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [score, setScore] = useState(0);
  const [showResult, setShowResult] = useState(false);
  const [selected, setSelected] = useState(null);
  const [answered, setAnswered] = useState(false);
  const [time, setTime] = useState(0);
  const [isPlaying, setIsPlaying] = useState(false);
  const [bestScore, setBestScore] = useState(() => {
    const saved = localStorage.getItem('mathQuizBestScore');
    return saved ? parseInt(saved, 10) : 0;
  });

  const questions = [
    // ============================================
    // ADDITION - 20 კითხვა
    // ============================================
    { question: '5 + 3 = ?', options: ['5', '7', '8', '9'], correct: 2 },
    { question: '12 + 7 = ?', options: ['17', '18', '19', '20'], correct: 2 },
    { question: '25 + 13 = ?', options: ['36', '37', '38', '39'], correct: 2 },
    { question: '48 + 36 = ?', options: ['82', '83', '84', '85'], correct: 2 },
    { question: '67 + 28 = ?', options: ['93', '94', '95', '96'], correct: 2 },
    { question: '15 + 27 = ?', options: ['40', '41', '42', '43'], correct: 2 },
    { question: '56 + 34 = ?', options: ['88', '89', '90', '91'], correct: 2 },
    { question: '73 + 19 = ?', options: ['90', '91', '92', '93'], correct: 2 },
    { question: '84 + 16 = ?', options: ['98', '99', '100', '101'], correct: 2 },
    { question: '29 + 48 = ?', options: ['75', '76', '77', '78'], correct: 2 },
    { question: '61 + 29 = ?', options: ['88', '89', '90', '91'], correct: 2 },
    { question: '47 + 36 = ?', options: ['81', '82', '83', '84'], correct: 2 },
    { question: '54 + 28 = ?', options: ['80', '81', '82', '83'], correct: 2 },
    { question: '76 + 15 = ?', options: ['89', '90', '91', '92'], correct: 2 },
    { question: '82 + 17 = ?', options: ['97', '98', '99', '100'], correct: 2 },
    { question: '39 + 44 = ?', options: ['81', '82', '83', '84'], correct: 2 },
    { question: '58 + 36 = ?', options: ['92', '93', '94', '95'], correct: 2 },
    { question: '67 + 24 = ?', options: ['89', '90', '91', '92'], correct: 2 },
    { question: '71 + 19 = ?', options: ['88', '89', '90', '91'], correct: 2 },
    { question: '46 + 37 = ?', options: ['81', '82', '83', '84'], correct: 2 },

    // ============================================
    // SUBTRACTION - 20 კითხვა
    // ============================================
    { question: '15 - 7 = ?', options: ['6', '7', '8', '9'], correct: 2 },
    { question: '25 - 12 = ?', options: ['11', '12', '13', '14'], correct: 2 },
    { question: '43 - 18 = ?', options: ['23', '24', '25', '26'], correct: 2 },
    { question: '56 - 29 = ?', options: ['25', '26', '27', '28'], correct: 2 },
    { question: '74 - 38 = ?', options: ['34', '35', '36', '37'], correct: 2 },
    { question: '82 - 47 = ?', options: ['33', '34', '35', '36'], correct: 2 },
    { question: '91 - 56 = ?', options: ['33', '34', '35', '36'], correct: 2 },
    { question: '67 - 28 = ?', options: ['37', '38', '39', '40'], correct: 2 },
    { question: '54 - 19 = ?', options: ['33', '34', '35', '36'], correct: 2 },
    { question: '83 - 46 = ?', options: ['35', '36', '37', '38'], correct: 2 },
    { question: '76 - 38 = ?', options: ['36', '37', '38', '39'], correct: 2 },
    { question: '92 - 57 = ?', options: ['33', '34', '35', '36'], correct: 2 },
    { question: '85 - 49 = ?', options: ['34', '35', '36', '37'], correct: 2 },
    { question: '63 - 27 = ?', options: ['34', '35', '36', '37'], correct: 2 },
    { question: '71 - 34 = ?', options: ['35', '36', '37', '38'], correct: 2 },
    { question: '58 - 29 = ?', options: ['27', '28', '29', '30'], correct: 2 },
    { question: '96 - 47 = ?', options: ['47', '48', '49', '50'], correct: 2 },
    { question: '74 - 36 = ?', options: ['36', '37', '38', '39'], correct: 2 },
    { question: '82 - 55 = ?', options: ['25', '26', '27', '28'], correct: 2 },
    { question: '97 - 68 = ?', options: ['27', '28', '29', '30'], correct: 2 },

    // ============================================
    // MULTIPLICATION - 20 კითხვა
    // ============================================
    { question: '3 × 4 = ?', options: ['10', '12', '14', '16'], correct: 1 },
    { question: '5 × 6 = ?', options: ['28', '29', '30', '31'], correct: 2 },
    { question: '7 × 8 = ?', options: ['54', '55', '56', '57'], correct: 2 },
    { question: '4 × 9 = ?', options: ['34', '35', '36', '37'], correct: 2 },
    { question: '6 × 7 = ?', options: ['40', '41', '42', '43'], correct: 2 },
    { question: '8 × 9 = ?', options: ['70', '71', '72', '73'], correct: 2 },
    { question: '3 × 7 = ?', options: ['19', '20', '21', '22'], correct: 2 },
    { question: '5 × 8 = ?', options: ['38', '39', '40', '41'], correct: 2 },
    { question: '6 × 9 = ?', options: ['52', '53', '54', '55'], correct: 2 },
    { question: '4 × 8 = ?', options: ['30', '31', '32', '33'], correct: 2 },
    { question: '7 × 9 = ?', options: ['61', '62', '63', '64'], correct: 2 },
    { question: '3 × 9 = ?', options: ['25', '26', '27', '28'], correct: 2 },
    { question: '5 × 7 = ?', options: ['33', '34', '35', '36'], correct: 2 },
    { question: '8 × 8 = ?', options: ['62', '63', '64', '65'], correct: 2 },
    { question: '4 × 6 = ?', options: ['22', '23', '24', '25'], correct: 2 },
    { question: '6 × 8 = ?', options: ['46', '47', '48', '49'], correct: 2 },
    { question: '3 × 8 = ?', options: ['22', '23', '24', '25'], correct: 2 },
    { question: '7 × 7 = ?', options: ['47', '48', '49', '50'], correct: 2 },
    { question: '5 × 9 = ?', options: ['43', '44', '45', '46'], correct: 2 },
    { question: '9 × 9 = ?', options: ['79', '80', '81', '82'], correct: 2 },

    // ============================================
    // DIVISION - 20 კითხვა
    // ============================================
    { question: '20 ÷ 4 = ?', options: ['4', '5', '6', '7'], correct: 1 },
    { question: '36 ÷ 6 = ?', options: ['4', '5', '6', '7'], correct: 2 },
    { question: '42 ÷ 7 = ?', options: ['4', '5', '6', '7'], correct: 2 },
    { question: '72 ÷ 8 = ?', options: ['7', '8', '9', '10'], correct: 2 },
    { question: '56 ÷ 7 = ?', options: ['6', '7', '8', '9'], correct: 2 },
    { question: '81 ÷ 9 = ?', options: ['7', '8', '9', '10'], correct: 2 },
    { question: '48 ÷ 6 = ?', options: ['6', '7', '8', '9'], correct: 2 },
    { question: '64 ÷ 8 = ?', options: ['6', '7', '8', '9'], correct: 2 },
    { question: '54 ÷ 9 = ?', options: ['4', '5', '6', '7'], correct: 2 },
    { question: '28 ÷ 4 = ?', options: ['5', '6', '7', '8'], correct: 2 },
    { question: '35 ÷ 5 = ?', options: ['5', '6', '7', '8'], correct: 2 },
    { question: '63 ÷ 9 = ?', options: ['5', '6', '7', '8'], correct: 2 },
    { question: '49 ÷ 7 = ?', options: ['5', '6', '7', '8'], correct: 2 },
    { question: '32 ÷ 4 = ?', options: ['6', '7', '8', '9'], correct: 2 },
    { question: '45 ÷ 5 = ?', options: ['7', '8', '9', '10'], correct: 2 },
    { question: '72 ÷ 9 = ?', options: ['6', '7', '8', '9'], correct: 2 },
    { question: '27 ÷ 3 = ?', options: ['7', '8', '9', '10'], correct: 2 },
    { question: '40 ÷ 5 = ?', options: ['6', '7', '8', '9'], correct: 2 },
    { question: '84 ÷ 7 = ?', options: ['10', '11', '12', '13'], correct: 2 },
    { question: '96 ÷ 8 = ?', options: ['10', '11', '12', '13'], correct: 2 },

    // ============================================
    // EXPONENTS - 10 კითხვა
    // ============================================
    { question: '2² = ?', options: ['2', '3', '4', '5'], correct: 2 },
    { question: '3² = ?', options: ['6', '7', '8', '9'], correct: 3 },
    { question: '4² = ?', options: ['14', '15', '16', '17'], correct: 2 },
    { question: '5² = ?', options: ['23', '24', '25', '26'], correct: 2 },
    { question: '2³ = ?', options: ['6', '7', '8', '9'], correct: 2 },
    { question: '3³ = ?', options: ['25', '26', '27', '28'], correct: 2 },
    { question: '4³ = ?', options: ['62', '63', '64', '65'], correct: 2 },
    { question: '5³ = ?', options: ['123', '124', '125', '126'], correct: 2 },
    { question: '6² = ?', options: ['34', '35', '36', '37'], correct: 2 },
    { question: '7² = ?', options: ['47', '48', '49', '50'], correct: 2 },

    // ============================================
    // SQUARE ROOTS - 10 კითხვა
    // ============================================
    { question: '√4 = ?', options: ['1', '2', '3', '4'], correct: 1 },
    { question: '√9 = ?', options: ['2', '3', '4', '5'], correct: 1 },
    { question: '√16 = ?', options: ['2', '3', '4', '5'], correct: 2 },
    { question: '√25 = ?', options: ['3', '4', '5', '6'], correct: 2 },
    { question: '√36 = ?', options: ['4', '5', '6', '7'], correct: 2 },
    { question: '√49 = ?', options: ['5', '6', '7', '8'], correct: 2 },
    { question: '√64 = ?', options: ['6', '7', '8', '9'], correct: 2 },
    { question: '√81 = ?', options: ['7', '8', '9', '10'], correct: 2 },
    { question: '√100 = ?', options: ['8', '9', '10', '11'], correct: 2 },
    { question: '√144 = ?', options: ['10', '11', '12', '13'], correct: 2 },
  ];

  useEffect(() => {
    let timer;
    if (isPlaying && !showResult) {
      timer = setInterval(() => setTime(t => t + 1), 1000);
    }
    return () => clearInterval(timer);
  }, [isPlaying, showResult]);

  const startGame = () => {
    setIsPlaying(true);
    setTime(0);
  };

  useEffect(() => {
    startGame();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleAnswer = (index) => {
    if (answered) return;
    setSelected(index);
    setAnswered(true);
    
    const isCorrect = index === questions[currentQuestion].correct;
    const newScore = isCorrect ? score + 1 : score;
    setScore(newScore);
    
    setTimeout(() => {
      if (currentQuestion < questions.length - 1) {
        setCurrentQuestion(currentQuestion + 1);
        setSelected(null);
        setAnswered(false);
      } else {
        setShowResult(true);
        setIsPlaying(false);
        if (newScore > bestScore) {
          setBestScore(newScore);
          localStorage.setItem('mathQuizBestScore', newScore.toString());
        }
      }
    }, 1000);
  };

  const resetQuiz = () => {
    setCurrentQuestion(0);
    setScore(0);
    setShowResult(false);
    setSelected(null);
    setAnswered(false);
    setTime(0);
    setIsPlaying(true);
  };

  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${String(secs).padStart(2, '0')}`;
  };

  const pageStyle = {
    minHeight: '100vh',
    background: isDarkMode 
      ? 'linear-gradient(135deg, #0a0a1a 0%, #1a1a2e 100%)' 
      : 'linear-gradient(135deg, #f5f5f5 0%, #e8e8e8 100%)',
    padding: 'clamp(12px, 3vw, 20px)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  };

  const containerStyle = {
    maxWidth: 'min(550px, 95vw)',
    width: '100%',
    padding: 'clamp(15px, 4vw, 35px)',
    background: isDarkMode ? 'rgba(26, 26, 46, 0.9)' : 'rgba(255, 255, 255, 0.9)',
    borderRadius: 'clamp(16px, 2vw, 20px)',
    backdropFilter: 'blur(20px)',
    boxShadow: isDarkMode 
      ? '0 20px 60px rgba(0,0,0,0.5), inset 0 1px 0 rgba(255,255,255,0.1)' 
      : '0 20px 60px rgba(0,0,0,0.1), inset 0 1px 0 rgba(255,255,255,0.5)',
    border: isDarkMode ? '1px solid rgba(255,255,255,0.1)' : '1px solid rgba(0,0,0,0.05)',
    animation: 'slideUp 0.6s ease-out'
  };

  return (
    <div style={pageStyle}>
      <style>
        {`
          @keyframes slideUp {
            from { opacity: 0; transform: translateY(30px); }
            to { opacity: 1; transform: translateY(0); }
          }
          @keyframes pulse {
            0%, 100% { transform: scale(1); }
            50% { transform: scale(1.05); }
          }
          @keyframes shimmer {
            0% { background-position: -200% center; }
            100% { background-position: 200% center; }
          }
          .game-title {
            background: linear-gradient(135deg, #f6d365 0%, #fda085 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            background-size: 200% auto;
            animation: shimmer 3s linear infinite;
          }
        `}
      </style>

      <div style={containerStyle}>
        <Link to="/games" style={{
          padding: 'clamp(10px, 1.5vw, 12px) clamp(20px, 3vw, 28px)',
          margin: 'clamp(8px, 1vw, 10px) 0',
          background: isDarkMode ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.05)',
          color: isDarkMode ? '#fff' : '#000',
          textDecoration: 'none',
          borderRadius: 'clamp(10px, 1.5vw, 12px)',
          backdropFilter: 'blur(10px)',
          border: isDarkMode ? '1px solid rgba(255,255,255,0.1)' : '1px solid rgba(0,0,0,0.05)',
          transition: 'all 0.3s',
          fontSize: 'clamp(13px, 1.5vw, 15px)'
        }}
        onMouseEnter={(e) => {
          e.target.style.transform = 'translateX(-5px)';
          e.target.style.background = isDarkMode ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.1)';
        }}
        onMouseLeave={(e) => {
          e.target.style.transform = 'translateX(0)';
          e.target.style.background = isDarkMode ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.05)';
        }}>
          ← თამაშებში დაბრუნება
        </Link>

        <h1 style={{ 
          textAlign: 'center',
          fontSize: 'clamp(22px, 4vw, 36px)',
          marginBottom: '5px'
        }}>
          <span className="game-title">📐 მათემატიკური ქვიზი</span>
        </h1>
        <p style={{ 
          color: isDarkMode ? '#aaa' : '#666', 
          textAlign: 'center',
          fontSize: 'clamp(12px, 1.5vw, 16px)'
        }}>
          დააჭირე სწორ პასუხს!
        </p>

        {!showResult ? (
          <>
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(70px, 1fr))',
              gap: 'clamp(8px, 1vw, 10px)',
              margin: 'clamp(15px, 2vw, 20px) 0',
              padding: 'clamp(10px, 1.5vw, 15px)',
              background: isDarkMode ? 'rgba(0,0,0,0.3)' : 'rgba(0,0,0,0.03)',
              borderRadius: 'clamp(10px, 1.5vw, 12px)',
              textAlign: 'center'
            }}>
              <div>
                <div style={{ fontSize: 'clamp(18px, 2.5vw, 20px)', color: '#FF6B6B' }}>📝</div>
                <div style={{ fontSize: 'clamp(12px, 1.3vw, 14px)', color: isDarkMode ? '#fff' : '#000' }}>
                  {currentQuestion + 1}/{questions.length}
                </div>
                <div style={{ fontSize: 'clamp(8px, 0.8vw, 10px)', color: isDarkMode ? '#666' : '#999' }}>კითხვა</div>
              </div>
              <div>
                <div style={{ fontSize: 'clamp(18px, 2.5vw, 20px)', color: '#4ECDC4' }}>✅</div>
                <div style={{ fontSize: 'clamp(12px, 1.3vw, 14px)', color: isDarkMode ? '#fff' : '#000' }}>{score}</div>
                <div style={{ fontSize: 'clamp(8px, 0.8vw, 10px)', color: isDarkMode ? '#666' : '#999' }}>სწორი</div>
              </div>
              <div>
                <div style={{ fontSize: 'clamp(18px, 2.5vw, 20px)', color: '#FFD93D' }}>⏱️</div>
                <div style={{ fontSize: 'clamp(12px, 1.3vw, 14px)', color: isDarkMode ? '#fff' : '#000' }}>{formatTime(time)}</div>
                <div style={{ fontSize: 'clamp(8px, 0.8vw, 10px)', color: isDarkMode ? '#666' : '#999' }}>დრო</div>
              </div>
            </div>

            <h3 style={{ 
              color: isDarkMode ? '#fff' : '#000', 
              marginBottom: 'clamp(20px, 2.5vw, 25px)',
              fontSize: 'clamp(16px, 2.5vw, 24px)',
              textAlign: 'center',
              padding: 'clamp(15px, 2vw, 20px)',
              background: isDarkMode ? 'rgba(0,0,0,0.2)' : 'rgba(0,0,0,0.02)',
              borderRadius: 'clamp(10px, 1.5vw, 12px)',
              border: isDarkMode ? '1px solid rgba(255,255,255,0.05)' : '1px solid rgba(0,0,0,0.05)'
            }}>
              {questions[currentQuestion].question}
            </h3>

            <div style={{ 
              display: 'grid', 
              gridTemplateColumns: 'repeat(2, 1fr)',
              gap: 'clamp(10px, 1.5vw, 12px)'
            }}>
              {questions[currentQuestion].options.map((opt, idx) => {
                const isCorrect = idx === questions[currentQuestion].correct;
                const isSelected = selected === idx;
                let bgColor = isDarkMode ? 'rgba(26, 26, 46, 0.8)' : 'rgba(255,255,255,0.8)';
                let borderColor = isDarkMode ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.05)';
                let textColor = isDarkMode ? '#fff' : '#000';

                if (isSelected) {
                  if (isCorrect) {
                    bgColor = 'linear-gradient(135deg, #4ade80, #22d3ee)';
                    borderColor = '#4ade80';
                    textColor = '#fff';
                  } else {
                    bgColor = 'linear-gradient(135deg, #f87171, #ef4444)';
                    borderColor = '#f87171';
                    textColor = '#fff';
                  }
                } else if (answered && isCorrect) {
                  bgColor = 'linear-gradient(135deg, #4ade80, #22d3ee)';
                  borderColor = '#4ade80';
                  textColor = '#fff';
                }

                return (
                  <button
                    key={idx}
                    onClick={() => handleAnswer(idx)}
                    style={{
                      padding: 'clamp(12px, 2vw, 18px)',
                      borderRadius: 'clamp(10px, 1.5vw, 12px)',
                      border: '2px solid',
                      borderColor: borderColor,
                      background: bgColor,
                      color: textColor,
                      cursor: answered ? 'default' : 'pointer',
                      fontSize: 'clamp(14px, 2vw, 20px)',
                      transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                      fontWeight: isSelected ? 'bold' : 'normal',
                      boxShadow: isSelected 
                        ? '0 4px 20px rgba(102,126,234,0.3)' 
                        : 'none',
                      transform: isSelected ? 'scale(1.02)' : 'scale(1)',
                      touchAction: 'manipulation',
                      WebkitTapHighlightColor: 'transparent'
                    }}
                    disabled={answered}
                    onMouseEnter={(e) => {
                      if (!answered && !isSelected) {
                        e.target.style.transform = 'scale(1.02)';
                        e.target.style.boxShadow = '0 4px 20px rgba(102,126,234,0.2)';
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (!answered && !isSelected) {
                        e.target.style.transform = 'scale(1)';
                        e.target.style.boxShadow = 'none';
                      }
                    }}
                  >
                    {opt}
                    {isSelected && (
                      <span style={{ marginLeft: '10px' }}>
                        {isCorrect ? ' ✅' : ' ❌'}
                      </span>
                    )}
                  </button>
                );
              })}
            </div>
          </>
        ) : (
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: 'clamp(48px, 10vw, 80px)', margin: '20px 0' }}>
              {score >= questions.length * 0.8 ? '🎉' : 
               score >= questions.length * 0.5 ? '😊' : '😅'}
            </div>
            <h2 style={{ color: isDarkMode ? '#fff' : '#000', marginBottom: '10px', fontSize: 'clamp(24px, 3vw, 32px)' }}>
              🏁 დასრულდა!
            </h2>
            <p style={{ 
              fontSize: 'clamp(28px, 5vw, 40px)', 
              color: isDarkMode ? '#fff' : '#000', 
              fontWeight: 'bold' 
            }}>
              {score}/{questions.length}
            </p>
            <p style={{ 
              color: isDarkMode ? '#aaa' : '#666',
              fontSize: 'clamp(14px, 1.5vw, 18px)'
            }}>
              📊 სიზუსტე: {Math.round((score / questions.length) * 100)}%
            </p>
            <p style={{ 
              color: isDarkMode ? '#aaa' : '#666',
              fontSize: 'clamp(12px, 1.5vw, 14px)',
              marginTop: '5px'
            }}>
              ⏱️ დრო: {formatTime(time)}
            </p>
            <div style={{
              margin: '15px 0',
              padding: '12px',
              background: isDarkMode ? 'rgba(0,0,0,0.3)' : 'rgba(0,0,0,0.03)',
              borderRadius: '10px'
            }}>
              <span style={{ color: '#FFD93D' }}>🏆</span>
              <span style={{ color: isDarkMode ? '#fff' : '#000', marginLeft: '8px' }}>
                საუკეთესო: {bestScore}
              </span>
            </div>
            <button
              onClick={resetQuiz}
              style={{
                padding: 'clamp(12px, 1.5vw, 16px) clamp(30px, 5vw, 50px)',
                background: 'linear-gradient(135deg, #f6d365 0%, #fda085 100%)',
                color: '#fff',
                border: 'none',
                borderRadius: 'clamp(10px, 1.5vw, 12px)',
                fontSize: 'clamp(14px, 1.5vw, 18px)',
                cursor: 'pointer',
                marginTop: '20px',
                transition: 'all 0.3s',
                fontWeight: 'bold',
                boxShadow: '0 4px 20px rgba(253,160,133,0.3)',
                touchAction: 'manipulation',
                width: '100%',
                maxWidth: '300px'
              }}
              onMouseEnter={(e) => {
                e.target.style.transform = 'translateY(-2px) scale(1.02)';
                e.target.style.boxShadow = '0 8px 30px rgba(253,160,133,0.4)';
              }}
              onMouseLeave={(e) => {
                e.target.style.transform = 'translateY(0) scale(1)';
                e.target.style.boxShadow = '0 4px 20px rgba(253,160,133,0.3)';
              }}
            >
              🔄 თავიდან
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default MathQuiz;